// extracted by mini-css-extract-plugin
export default {"album":"AlbumItem_album__xifEv","desc":"AlbumItem_desc__XJmXU","name":"AlbumItem_name__NxLSe","counts":"AlbumItem_counts__qSo0h"};